import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import {
  getActionableDescriptionQualityReasons,
  TKeyInitiative,
} from 'partner360/entities/keyInitiatives'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { getDescriptionQualityReasonTranslation } from 'partner360/features/keyInitiatives/ui/helpers/getDescriptionQualityReasonTranslation'
import { IDescriptionQualityGapInitiative } from 'partner360/features/keyInitiatives/ui/keyInitiativesQuality/models'

interface IUseFinancialTableConfigParams {
  onEditInitiative: (initiative: TKeyInitiative) => void
}

export const useDescriptionQualityColumns = ({
  onEditInitiative,
}: IUseFinancialTableConfigParams) => {
  const descriptionQualityGapColumns = useMemo<IColumn<IDescriptionQualityGapInitiative>[]>(
    () => [
      {
        field: 'Name',
        title: TRANSLATION_KEYS.quality.details.name,
        titleRender: () => <Translation text={TRANSLATION_KEYS.quality.details.name} />,
        renderFunction: (item) => item.Name || '',
      },
      {
        field: 'Description',
        title: TRANSLATION_KEYS.quality.details.description,
        titleRender: () => <Translation text={TRANSLATION_KEYS.quality.details.description} />,
        renderFunction: (item) => item.Description || '',
      },
      {
        field: 'reasons',
        title: TRANSLATION_KEYS.quality.details.suggestions,
        titleRender: () => <Translation text={TRANSLATION_KEYS.quality.details.suggestions} />,
        renderFunction: (item) => {
          const actionableReasons = getActionableDescriptionQualityReasons(item.reasons)

          return (
            <>
              {actionableReasons.map((reason, index) => (
                <span key={reason}>
                  {index > 0 && ', '}
                  <Translation span text={getDescriptionQualityReasonTranslation(reason, true)} />
                </span>
              ))}
            </>
          )
        },
        disableSort: true,
      },
    ],
    []
  )

  const descriptionQualityGapRowActions = useMemo(
    () => [
      {
        id: 'edit',
        action: (row: IDescriptionQualityGapInitiative) => onEditInitiative(row.initiative),
        title: 'Edit',
        icon: 'kbase kbase-edit kbase-sm',
      },
    ],
    [onEditInitiative]
  )

  return {
    descriptionQualityGapColumns,
    descriptionQualityGapRowActions,
  }
}
